import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
// Utils and Helpers
import { KYC_STATUS } from 'helpers/constants';
// Assets
import './KYCStatus.css';

const KYCStatus = ({ user }) => {
    if (user.kyc_status === KYC_STATUS.NOT_SUBMITTED || user.kyc_status === null) {
        return <Chip label="Not Submitted" className="kyc-status__chip kyc-status__chip-secondary" />;
    }
    if (user.kyc_status === KYC_STATUS.NOT_STARTED) {
        return <Chip label="Not Started" className="kyc-status__chip kyc-status__chip-secondary" />;
    }
    if (user.kyc_status === KYC_STATUS.STARTED) {
        return <Chip label="Started" className="kyc-status__chip kyc-status__chip-pending" />;
    }
    if (user.kyc_status === KYC_STATUS.REVIEW) {
        return <Chip label="In Review" className="kyc-status__chip kyc-status__chip-warning" />;
    }
    if (user.kyc_status === KYC_STATUS.APPROVED) {
        return <Chip label="Approved" className="kyc-status__chip kyc-status__chip-success" />;
    }
    if (user.kyc_status === KYC_STATUS.DECLINED) {
        return <Chip label="Declined" className="kyc-status__chip kyc-status__chip-danger" />;
    }

    return <Chip label="N/A" className="kyc-status__chip kyc-status__chip-secondary" />;
};

KYCStatus.propTypes = {
    user: PropTypes.object.isRequired
};

export default KYCStatus;
